import globalConfig from './globalConfig'
import { clearDisable } from '../../plugins/clickThrottling'
const { global } = globalConfig

let isUpdateTriggerBridgeReady = false

export default {
  methods: {},
  bridgeReadyCallback: '',
  genteratecallbackName: function () {
    let timestamp = new Date().getTime()
    return 'sdkCallBack' + timestamp
  },
  gernerateNewCallback: function (callback, globalCallbackName) {
    return function () {
      clearDisable()
      let res = callback.apply(callback, arguments)
      delete global[globalCallbackName]
      return res
    }
  },
  callSdkMethod: function (method, params, callback) {
    if (typeof params == 'function') {
      callback = params
      params = {}
    }

    if (typeof global !== 'undefined' && typeof callback === 'function') {
      let globalCallbackName = this.genteratecallbackName()
      while (global[globalCallbackName]) {
        globalCallbackName = this.genteratecallbackName()
      }
      // 全局声明一个临时函数地址，地址指向回调函数。执行回调之后，会自动删除这个全局函数。
      global[globalCallbackName] = this.gernerateNewCallback(
        callback,
        globalCallbackName
      )
      params['callback'] = globalCallbackName
    }
    let paramsStr = JSON.stringify(params)

    /*
            js 调用sdk 的方式。
            对象名：sdkCtrl
            方法名：callSDKMethodWithParameters(method,parameters)
            @method   调用的功能，。
            @parameters 需要传递的参数，键值对的方式。
            如果有回调，在 parameters 包含 callback 参数， 参数值必须是window全局下的一个函数。
        */
    // andoid
    if (
      global !== 'undefined' &&
      global.sdkCtrl &&
      typeof global.sdkCtrl.callSDKMethodWithParameters == 'function'
    ) {
      /* eslint-disbale no-useless-call */
      global.sdkCtrl.callSDKMethodWithParameters(method, paramsStr)
      /* eslint-disable  brace-style */
    }

    // ios
    /* eslint-disable  brace-style */
    else if (
      global !== 'undefined' &&
      global.webkit &&
      global.webkit.messageHandlers &&
      global.webkit.messageHandlers.callSDKMethodWithParameters
    ) {
      window.webkit.messageHandlers.callSDKMethodWithParameters.postMessage({
        method,
        params
      })
    }
    // 测试
    else {
      let debugData = arguments.length == 4 ? arguments[3] : arguments[2]
      typeof callback == 'function' && callback(debugData)
    }
  },

  runInsdk() {
    let runInAndroid =
      global !== 'undefined' &&
      global.sdkCtrl &&
      typeof global.sdkCtrl.callSDKMethodWithParameters == 'function'
    let runInIOS =
      global !== 'undefined' &&
      global.webkit &&
      global.webkit.messageHandlers &&
      global.webkit.messageHandlers.callSDKMethodWithParameters
    return runInAndroid || runInIOS
  },

  createReadyEvent: function () {
    if (
      global !== 'undefined' &&
      typeof this.bridgeReadyCallback === 'function'
    ) {
      // 原生app 在装载页面成功后，触发 window.triggerBridgeReady 告诉前端，前端可以调用原声的方法.
      global.triggerBridgeReady = function () {
        this.bridgeReadyCallback()
      }.bind(this)
    }
  },
  listendRendy: function (callback) {
    this.bridgeReadyCallback = callback
    if (!isUpdateTriggerBridgeReady) {
      this.createReadyEvent()
      isUpdateTriggerBridgeReady = true
    }
  },
  injectObjFinish() {
    let androidSuccess =
      global &&
      global.sdkCtrl &&
      typeof global.sdkCtrl.callSDKMethodWithParameters == 'function'
    let iosSuccesss =
      global !== 'undefined' &&
      global.webkit &&
      global.webkit.messageHandlers &&
      global.webkit.messageHandlers.callSDKMethodWithParameters
    return androidSuccess || iosSuccesss
  },
  onReady(callback) {
    if (this.injectObjFinish()) {
      if (typeof callback == 'function') {
        callback(this)
      }
    } else {
      this.listendRendy(callback)
    }
  },
  callJavascriptMethod(method, paramsStr) {
    let params = {}
    if (paramsStr) {
      params = JSON.parse(paramsStr)
    }
    // 构造回调函数
    let callback = function () {
      let callbackMethodName = params['callback']
      if (params['callback']) {
        let ars = Array.prototype.slice.call(arguments, 0)
        ars.unshift(callbackMethodName)
        this.callSdkMethod.apply(this, ars)
      }
    }
    if (typeof this.methods[method] === 'function') {
      this.methods[method](params, callback)
    }
  },
  /**
   * @param  methodName 注册的函数名
   *
   * @param  handler 注册的函数体
   * function(param,callback){
   *      如果原生需要前端回调，则调用callback
   *      @callback   function(params){
   *
   *      }
   *      @callback @param params   [可选] 必须为对象字面量。
   * }
   * * */
  registHandler(methodName, handler) {
    if (
      typeof global !== 'undefined' &&
      (global.callJavascriptMethod === undefined ||
        global.callJavascriptMethod.name === 'initBridgeFunction')
    ) {
      global.callJavascriptMethod = this.callJavascriptMethod.bind(this)
    }
    // 不能重复注册，覆盖了其他函数
    if (typeof this.methods[methodName] === 'function') {
      return
    }
    // 注册时必须有函数实体
    if (typeof handler !== 'function') {
      return
    }
    this.methods[methodName] = handler
  }
}
